function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayable3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8849"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8422",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8845"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45531",
    d: "M-1744.914-65.009h-2.073q0-27.765-.013-55.53c0-.43.133-.458.49-.458q27.517.013 55.034 0c.392 0 .475.078.475.474q-.018 27.52 0 55.04c0 .438-.131.487-.516.487q-26.317-.015-52.634-.009c.025-.292.284-.3.473-.361 2.863-.953 5.745-1.846 8.61-2.79 2.02-.665 4.049-1.3 6.068-1.968 3.869-1.218 7.72-2.491 11.577-3.742.73-.213 1.459-.432 2.179-.68q1.972-.678.521-2.138c-.511-.515-1.025-1.025-1.539-1.538-1.221-1.252-2.472-2.475-3.705-3.716a4.888 4.888 0 0 1-.161-.161q-2.22-2.23-4.452-4.449-1.857-1.873-3.733-3.728-2.863-2.874-5.735-5.737c-.064-.064-.127-.13-.2-.19a1.012 1.012 0 0 0-1.739.425c-.417 1.123-.729 2.281-1.1 3.42-.185.694-.433 1.367-.645 2.052-.448 1.218-.77 2.476-1.2 3.7-.54 1.523-.964 3.083-1.5 4.606-.4 1.238-.78 2.482-1.2 3.713-.449 1.487-.96 2.954-1.437 4.431-.358 1.225-.792 2.425-1.181 3.64a1.358 1.358 0 0 1-.052.157c-.4 1.1-.686 2.24-1.088 3.341a1.123 1.123 0 0 0 .371 1.48.2.2 0 0 1 .105.229z",
    transform: "translate(1751 125)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45532",
    d: "M-1721.148 227.452c-2.18.718-4.358 1.442-6.541 2.152-2.719.884-5.441 1.756-8.161 2.639-.166.054-.361.056-.482.214h-.764c-.808-.556-.9-.828-.584-1.783l1.1-3.348a7.2 7.2 0 0 1 1.2-.065h13.309c.31.003.655-.076.923.191z",
    transform: "translate(1743.182 -172.466)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45533",
    d: "M-1720.746 175.088c.41-1.518.948-3 1.436-4.49a.928.928 0 0 1 .671-.167q8.534-.007 17.068 0a3.79 3.79 0 0 1 .433.033.6.6 0 0 1 .188.052 1.123 1.123 0 0 1-.582 1.777c-.95.358-1.918.67-2.887.972-2.008.626-4 1.3-6.008 1.932a1.062 1.062 0 0 1-.295.036c-3.047.053-6.094.017-9.14.023a1.215 1.215 0 0 1-.884-.168z",
    transform: "translate(1728.575 -123.928)",
    style: {
      fill: "#fedf7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45534",
    d: "M-1600.869-119.081c.32-.268.65-.526.956-.809.24-.223.435-.231.63.041a6.567 6.567 0 0 1 1.31 4.714 6.79 6.79 0 0 1-3.846 5.571c-.37.186-.3.443-.23.728a6.765 6.765 0 0 1-.608 4.958 6.832 6.832 0 0 1-2.946 2.9.528.528 0 0 0-.334.719 6.908 6.908 0 0 1-5.181 8.485 10.24 10.24 0 0 1-1.344.176c-.214.022-.411-.022-.394-.313a1.072 1.072 0 0 1 .544-.343 6.757 6.757 0 0 0 4.094-7.661c-.173-.9-.173-.9.643-1.366a6.789 6.789 0 0 0 3.227-7.322c-.182-.8-.182-.8.518-1.208a6.78 6.78 0 0 0 3.537-5.946 5.808 5.808 0 0 0-.5-2.551c-.107-.243-.272-.492-.076-.773z",
    transform: "translate(1636.42 124.193)",
    style: {
      fill: "#80b3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45535",
    d: "m-1717.8 201.234.224-.024a6.676 6.676 0 0 1 1.56-.173c4.353 0 8.707 0 13.06.009.3 0 .667-.121.871.255-3.879 1.272-7.753 2.561-11.658 3.75l-13.234-.016h-1.688c-.176 0-.368.051-.513-.108h.021a.984.984 0 0 1 .592-.359c3.258-1.025 6.5-2.108 9.753-3.144.327-.111.674-.114 1.012-.19z",
    transform: "translate(1735.78 -150.066)",
    style: {
      fill: "#dc636e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45536",
    d: "M-1692.581 148.224h-18.316l1.2-3.718a.612.612 0 0 1 .19-.1 3.466 3.466 0 0 1 .759-.035c3.757 0 7.515.072 11.269-.027 2.447-.064 4.892-.091 7.339-.106a1.669 1.669 0 0 1 .949.173l.108.111a.756.756 0 0 1-.614.152q-2.891.007-5.781 0a.829.829 0 0 1-.568-.122c1.144 1.053 2.228 2.17 3.318 3.28a.4.4 0 0 1 .147.392z",
    transform: "translate(1720.162 -101.558)",
    style: {
      fill: "#e17f85"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45537",
    d: "M-1634.134 175.163c-.2-.14-.422-.075-.634-.076q-7.429-.012-14.857-.016c1.469-.611 3.018-.982 4.515-1.51 1.312-.462 2.645-.865 3.967-1.3.94-.308 1.176-.7 1-1.64.193-.22.459-.19.708-.191 1.882-.007 3.764 0 5.646 0a1.342 1.342 0 0 1 .73.168c.658.645 1.342 1.266 1.965 1.943a1.063 1.063 0 0 1-.424 1.769c-.854.322-1.741.571-2.616.853z",
    transform: "translate(1667.825 -123.927)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45538",
    d: "M-1512.824 123.835a1.84 1.84 0 0 1 .166.138c.807.845.789 1.125-.107 1.889-.249.212-.485.439-.736.648a.728.728 0 0 1-1.182-.073c-.688-.749-1.351-1.521-2.036-2.273-.527-.578-.87-.575-1.392 0-.7.783-1.411 1.565-2.089 2.371a1.613 1.613 0 0 1-1.172.565 2.6 2.6 0 0 1-2.7-1.188 17.765 17.765 0 0 0-1.578-1.8c-.459-.513-.842-.51-1.318.02-.753.838-1.508 1.674-2.247 2.523a1.368 1.368 0 0 1-.952.44 2.764 2.764 0 0 1-2.818-1.176c-.774-1.048-1.712-1.975-2.585-2.948-.739-.824-.727-1.042.136-1.756.345-.151.508.134.671.321.7.807 1.432 1.591 2.129 2.4.27.314.5.735.927.805a5.674 5.674 0 0 0 2-.018c.22-.043.351-.243.494-.41.673-.785 1.369-1.55 2.055-2.322a.961.961 0 0 1 1.66-.031c.734.778 1.432 1.591 2.136 2.4a1.324 1.324 0 0 0 .942.446 2.585 2.585 0 0 0 2.7-1.161 14.9 14.9 0 0 1 1.546-1.751.97.97 0 0 1 1.522.006c.616.69 1.242 1.372 1.843 2.074.494.578.77.612 1.38.169.185-.131.32-.371.605-.308z",
    transform: "translate(1570.86 -81.858)",
    style: {
      fill: "#dc636e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45539",
    d: "M-1600.968-113.374c.1.722.5 1.35.61 2.075a7.014 7.014 0 0 1-1.416 5.552 7.013 7.013 0 0 1-2.344 1.9.436.436 0 0 0-.272.593 6.788 6.788 0 0 1-2.021 6.931 4.761 4.761 0 0 1-1.469 1.014.57.57 0 0 0-.368.772 6.857 6.857 0 0 1-1.107 5.784 6.63 6.63 0 0 1-3.6 2.553c-.08-.873.138-1.737.087-2.609-.02-.353.214-.412.489-.442a3.415 3.415 0 0 0 3.116-2.626 3.352 3.352 0 0 0-.43-2.87.736.736 0 0 1-.066-.845c.316-.612.6-1.244.869-1.878a.6.6 0 0 1 .514-.407 3.577 3.577 0 0 0 2.589-5.45.868.868 0 0 1-.074-.907 68.74 68.74 0 0 0 .842-1.831.672.672 0 0 1 .567-.434 3.577 3.577 0 0 0 2.568-5.4c-.228-.388-.206-.606.164-.847a8.038 8.038 0 0 0 .752-.628z",
    transform: "translate(1636.519 118.486)",
    style: {
      fill: "#9cc5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45540",
    d: "M-1508.9 116.319c-.229.176-.455.355-.687.528a.843.843 0 0 1-1.311-.165 167.57 167.57 0 0 0-1.948-2.257.846.846 0 0 0-1.317.064c-.762.871-1.548 1.722-2.315 2.589a.863.863 0 0 1-.808.343.908.908 0 0 0-.326 0c-1.275.3-2.006-.472-2.712-1.334a32.303 32.303 0 0 0-1.47-1.667.729.729 0 0 0-1.212.021c-.755.827-1.487 1.676-2.219 2.525a1.094 1.094 0 0 1-.936.455 3.517 3.517 0 0 0-.87.005c-.83.16-1.31-.332-1.783-.879q-1.1-1.272-2.215-2.528c-.129-.146-.254-.317-.484-.319.255-.229.506-.464.767-.687a.722.722 0 0 1 1.18.059c.678.733 1.328 1.492 2 2.23.585.641.939.627 1.512-.029.694-.792 1.4-1.575 2.082-2.377a1.458 1.458 0 0 1 1.043-.483 2.614 2.614 0 0 1 2.754 1.182 17.463 17.463 0 0 0 1.5 1.723c.521.6.891.611 1.436.014.735-.8 1.465-1.614 2.178-2.438a1.532 1.532 0 0 1 1.044-.483 2.768 2.768 0 0 1 2.825 1.278c.692.931 1.523 1.758 2.292 2.63z",
    transform: "translate(1566.937 -74.342)",
    style: {
      fill: "#e18085"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45541",
    d: "m-1702.57 118.264-.115.018 1.494-4.571a.8.8 0 0 1 .506-.165c2.241 0 4.482-.048 6.721.026a.7.7 0 0 1 .2.048 1.791 1.791 0 0 1 .464.374q1.777 1.77 3.548 3.547a1.852 1.852 0 0 1 .286.328c.131.213.157.382-.181.372h-12.324a2.636 2.636 0 0 0-.599.023z",
    transform: "translate(1713.148 -75.329)",
    style: {
      fill: "#fedf7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45542",
    d: "M-1513.377-47.53c-.381-.657-.75-1.322-1.147-1.969-.251-.41-.034-.544.315-.643a4.144 4.144 0 0 1 2.446.218c1.021.325 1.038.336 1.261-.731a3.622 3.622 0 0 1 2.893-3.148 4.23 4.23 0 0 1 2.288.259c.137.047.274.095.408.15.418.173.641.064.715-.41a7.893 7.893 0 0 1 .324-1.315 3.521 3.521 0 0 1 4.362-2.239 13.871 13.871 0 0 0 .859 1.574c.31.588.2.857-.456 1.009a3.948 3.948 0 0 1-2.193-.2c-1.034-.35-1.044-.344-1.266.712a3.686 3.686 0 0 1-2.686 3.056 4.1 4.1 0 0 1-2.465-.129c-.172-.058-.347-.108-.517-.171-.353-.13-.555-.018-.628.354a8.323 8.323 0 0 1-.3 1.215 3.757 3.757 0 0 1-3.25 2.533 2.388 2.388 0 0 1-.963-.125z",
    transform: "translate(1552.519 70.751)",
    style: {
      fill: "#dcc7f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45543",
    d: "M-1506.024-46.765c.391-.181.787.045 1.2-.041a3.83 3.83 0 0 0 3.166-3.535c.116-.723.19-.77.876-.516a4.565 4.565 0 0 0 2.764.3 3.555 3.555 0 0 0 2.688-3.079v-.054c.18-1.049.2-1.068 1.2-.727a3.955 3.955 0 0 0 2.442.241c.514-.149.566-.261.3-.7-.282-.464-.561-.93-.831-1.4-.057-.1-.233-.257.056-.309a1.673 1.673 0 0 1 1.407.967c.369.686.766 1.358 1.169 2.025.209.346.132.522-.253.62a4.118 4.118 0 0 1-2.4-.156c-1.163-.4-1.1-.569-1.357.761a3.62 3.62 0 0 1-3.42 3.176 5.037 5.037 0 0 1-2.057-.437c-.672-.223-.729-.2-.836.492a4.039 4.039 0 0 1-1.838 3.059 3.838 3.838 0 0 1-3.793.025c-.278-.135-.337-.465-.483-.712z",
    transform: "translate(1545.166 69.987)",
    style: {
      fill: "#caaee9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45544",
    d: "M-1701.9 118.284c.179-.135.387-.072.58-.073q5.992-.006 11.985 0h.66l-4.406-4.446c.186-.234.454-.2.7-.2 1.886-.008 3.771 0 5.657 0a1.274 1.274 0 0 1 .729.176c1.536 1.45 3.015 2.956 4.485 4.471-6.689.021-13.377.163-20.067.1-.101-.006-.21-.02-.323-.028z",
    transform: "translate(1712.473 -75.349)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45545",
    d: "M-1679.934 49.873c.374-1.19.717-2.39 1.131-3.565a1.09 1.09 0 0 1 1.833-.366c2.008 1.992 3.994 4 5.989 6.008a.621.621 0 0 1-.544.186c-2.118 0-4.236.037-6.352-.017a.974.974 0 0 1-.185-.029 10.8 10.8 0 0 1-1.8-1.707.456.456 0 0 1-.072-.51z",
    transform: "translate(1693.753 -17.295)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45546",
    d: "M-1543.843 41.069a15.022 15.022 0 0 0-1.879.531c-.214.061-.426.14-.6-.076-.156-.2-.036-.377.061-.552.238-.428.453-.873.723-1.28.293-.44.194-.719-.24-.976s-.809-.553-1.221-.819a.436.436 0 0 1-.225-.5c.051-.221.23-.244.42-.27.5-.068 1-.156 1.5-.224.429-.058.646-.253.589-.723-.063-.521-.081-1.048-.116-1.572-.012-.187 0-.363.2-.466.233-.119.374.025.523.163.4.369.811.728 1.2 1.106a.465.465 0 0 0 .75 0c.4-.391.827-.763 1.241-1.144.124-.114.248-.215.435-.141.2.08.234.24.247.437.045.71-.187 1.406-.093 2.117-.1.332-.417.438-.664.611-.56.394-.594.5-.256 1.108.194.349.4.69.584 1.045a.65.65 0 0 1 .011.722c-.166.219-.426.161-.658.119a12.369 12.369 0 0 1-1.2-.344c-.651-.185-.73-.142-.989.469a1.564 1.564 0 0 1-.343.659z",
    transform: "translate(1580.367 -7.476)",
    style: {
      fill: "#fedf7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45547",
    d: "m-1666.9 89.231 7.079-.022 3.713 3.728-7.088.03-.106-.038a1.854 1.854 0 0 1-.524-.383c-.923-.929-1.853-1.85-2.772-2.782-.138-.145-.364-.264-.302-.533z",
    transform: "translate(1682.588 -54.554)",
    style: {
      fill: "#dc636e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45548",
    d: "m-1599.361 149.9-7.083.026-.106-.03-3.628-3.7h7.125z",
    transform: "translate(1634.131 -103.228)",
    style: {
      fill: "#dc636e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45549",
    d: "m-1717.679 202.388-11.049 3.58-.308.107a58.076 58.076 0 0 1 1.209-3.7z",
    transform: "translate(1735.656 -151.22)",
    style: {
      fill: "#e18085"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45550",
    d: "m-1688.7 88.161 3.046 3.1c.19.194.369.4.552.6l-7.334.006c.363-1.254.745-2.5 1.2-3.724a4.07 4.07 0 0 1 2.411-.006z",
    transform: "translate(1704.394 -53.483)",
    style: {
      fill: "#e18085"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45551",
    d: "M-1523.978 56.175a.724.724 0 0 1 .022-.215c.592-1.37.285-1.4 1.812-.909a7.632 7.632 0 0 0 .783.217c.171.036.4.1.5-.078a.554.554 0 0 0-.032-.57c-.263-.454-.515-.914-.778-1.368a.518.518 0 0 1 .221-.812c.343-.2.663-.44.993-.662a5.232 5.232 0 0 0 1.576.349 3.616 3.616 0 0 0 .534.1.444.444 0 0 1 .445.333c.053.237-.137.361-.3.474-.4.281-.8.575-1.221.818-.46.264-.485.556-.207.974s.5.844.739 1.27c.1.173.211.349.042.549a.433.433 0 0 1-.538.1c-.515-.171-1.045-.3-1.558-.475-.407-.141-.607.012-.739.384-.17.478-.367.946-.549 1.42-.082.214-.183.4-.455.392-.253-.007-.324-.207-.4-.39a46.21 46.21 0 0 1-.559-1.416.986.986 0 0 0-.331-.485z",
    transform: "translate(1560.502 -22.581)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45552",
    d: "M-1637.254-31.744c.232-.449.448-.908.7-1.343.218-.373.459-.364.7 0a1.953 1.953 0 0 1 .234.428 4.006 4.006 0 0 0 2.439 2.368c.221.094.5.179.513.5.01.335-.286.4-.506.491a4.3 4.3 0 0 0-2.548 2.563c-.079.208-.154.46-.456.479s-.373-.246-.483-.441c-.2-.362-.392-.733-.586-1.1-.17-.415.078-.651.381-.845.459-.293.952-.526 1.419-.8s.477-.391-.011-.692c-.418-.257-.87-.452-1.284-.712-.309-.202-.689-.4-.512-.896z",
    transform: "translate(1657.298 50.144)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45553",
    d: "M-1651.622-22.258c0 .431.314.631.632.812.441.252.889.491 1.339.726.181.095.384.184.4.407.015.24-.21.313-.382.409-.506.283-1.01.571-1.519.848a.765.765 0 0 0-.458.739 1.987 1.987 0 0 0-1.062-1.015c-.387-.2-.772-.4-1.141-.628-.413-.255-.406-.46.01-.7.359-.209.724-.411 1.095-.6a2.068 2.068 0 0 0 1.086-.998z",
    transform: "translate(1671.665 40.658)",
    style: {
      fill: "#fedf7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45554",
    d: "M-1408.172 4.074a7.371 7.371 0 0 1 .4-.764c.212-.314.521-.352.67.014a3.162 3.162 0 0 0 1.753 1.736c.321.144.276.39.031.6a.98.98 0 0 1-.276.17 2.308 2.308 0 0 0-1.378 1.367c-.083.212-.2.46-.475.466s-.359-.269-.469-.468-.184-.39-.275-.586c-.055-.35.208-.464.443-.6 1.056-.621 1.052-.614.025-1.242-.245-.152-.586-.278-.449-.693z",
    transform: "translate(1461.612 19.031)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45555",
    d: "M-1454.886 30.524a1.21 1.21 0 0 1-1.192 1.228 1.277 1.277 0 0 1-1.212-1.237 1.2 1.2 0 0 1 1.194-1.166 1.133 1.133 0 0 1 1.21 1.175z",
    transform: "translate(1503.54 -3.423)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45556",
    d: "M-1460.671-87.071a1.164 1.164 0 0 1-1.194-1.208 1.209 1.209 0 0 1 1.224-1.194 1.245 1.245 0 0 1 1.177 1.2 1.189 1.189 0 0 1-1.207 1.202z",
    transform: "translate(1507.447 98.071)",
    style: {
      fill: "#9dc5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45557",
    d: "M-1395.782 76.6a1.173 1.173 0 0 1-1.185 1.222 1.3 1.3 0 0 1-1.217-1.238 1.308 1.308 0 0 1 1.2-1.2 1.173 1.173 0 0 1 1.202 1.216z",
    transform: "translate(1453.053 -42.747)",
    style: {
      fill: "#9dc5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45558",
    d: "M-1571.987 88.551a1.172 1.172 0 0 1 1.254 1.152 1.26 1.26 0 0 1-1.193 1.249 1.286 1.286 0 0 1-1.235-1.216 1.2 1.2 0 0 1 1.174-1.185z",
    transform: "translate(1602.513 -53.992)",
    style: {
      fill: "#9dc5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45559",
    d: "M-1442.862 57.248a1.2 1.2 0 0 1-1.183 1.235 1.286 1.286 0 0 1-1.222-1.231 1.252 1.252 0 0 1 1.246-1.193 1.164 1.164 0 0 1 1.159 1.189z",
    transform: "translate(1493.27 -26.238)",
    style: {
      fill: "#e18086"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45560",
    d: "M-1608.844-64.726a1.245 1.245 0 0 1-1.211 1.228 1.3 1.3 0 0 1-1.214-1.239 1.242 1.242 0 0 1 1.2-1.184 1.2 1.2 0 0 1 1.225 1.195z",
    transform: "translate(1635.063 77.953)",
    style: {
      fill: "#e18086"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45561",
    d: "M-1416.933 10c.1.492.548.577.9.776.216.124.486.2.515.5.033.343-.3.353-.479.507-.307.263-.8.293-.95.751-.214-.394-.623-.525-.975-.737-.205-.124-.519-.149-.534-.473-.017-.357.322-.407.537-.536.364-.22.786-.361.986-.788z",
    transform: "translate(1470.372 13.104)",
    style: {
      fill: "#fedf7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45562",
    d: "m-1681.773 77.038-2.411.006.658-2.08a.769.769 0 0 0 .315.6c.484.486.959.982 1.438 1.474z",
    transform: "translate(1697.345 -42.386)",
    style: {
      fill: "#fede7d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayable3);
export default __webpack_public_path__ + "static/media/payable3.0ec562b48377c7d9ffd44ba723082c6e.svg";
export { ForwardRef as ReactComponent };